import {getLegalDocumentText} from 'Core/api/legalAcceptanceApi';
import {getLegalDocuments} from 'Core/api/legalDocumentApi';
import {
  getDocumentSummaries,
  getDocumentText,
  LegalDocumentActionType,
  loadDocumentSummaries,
  loadDocumentText,
} from 'Core/ducks/legalDocument';
import {all, takeLatest} from 'redux-saga/effects';
import {getApiCallGenerator} from 'Shared/utilities/sagaApiGenerators';

function* getLegalDocumentsFromApi(action: ReturnType<typeof getDocumentSummaries>) {
  yield getApiCallGenerator(getLegalDocuments, loadDocumentSummaries)(action);
}

function* getLegalDocumentsSaga() {
  yield takeLatest(LegalDocumentActionType.GET_DOCUMENT_SUMMARIES, getLegalDocumentsFromApi);
}

function* getLegalDocumentsTextFromApi(action: ReturnType<typeof getDocumentText>) {
  yield getApiCallGenerator(() => getLegalDocumentText(action.payload.id), loadDocumentText)(action);
}

function* getLegalDocumentTextSaga() {
  yield takeLatest(LegalDocumentActionType.GET_DOCUMENT_TEXT, getLegalDocumentsTextFromApi);
}

export default function*() {
  yield all([getLegalDocumentsSaga(), getLegalDocumentTextSaga()]);
}
